import { captureException, captureMessage } from '@/utils/errorMonitoring';

interface LogAuthDebugOptions {
  context?: Record<string, unknown>;
  error?: unknown;
}

export const logAuthDebug = (
  event: string,
  { context = {}, error }: LogAuthDebugOptions = {},
) => {
  const payload = {
    event,
    path: typeof window !== 'undefined' ? window.location.pathname : 'unknown',
    timestamp: new Date().toISOString(),
    ...context,
  };

  const message = `[auth-debug] ${event}`;

  captureMessage(message, { extra: payload, level: 'info' });
  // eslint-disable-next-line no-console -- intentional staging debug output
  console.info(message);

  if (error) {
    captureException(error);
  }
};
